import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { IActivityLogRepository } from '../entities/IActivityLogRepositoryImpl';
import { ActivityLog, ActivityLogDetails } from '../entities';
import { activityLogListResponseDTOToActivityLogListDataAdapter } from './activityLogListResponseDTOToActivityLogListDataAdapter';
import { activityLogDetailsResponseDTOtoActivityLogDetailsAdapter } from './activityLogDetailsResponseDTOtoActivityLogDetailsAdapter';

class ActivityLogRepositoryImpl implements IActivityLogRepository {
  constructor() {
    this.GetActivityLogList = this.GetActivityLogList.bind(this);
    this.GetActivityLogDetails = this.GetActivityLogDetails.bind(this);
  }

  GetActivityLogList(
    pageSize: number,
    pageOffset: number,
    successCallback?: SuccessCallback,
    errorCallback?: ErrorCallback,
  ): Promise<ActivityLog[]> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: `/secure-web/api/private/activity-log`,
        dataAdapter: activityLogListResponseDTOToActivityLogListDataAdapter,
        params: {
          pageSize,
          pageOffset,
        },
        nextCallback: successCallback,
        onErrorCallback: errorCallback,
      },
    });
  }
  GetActivityLogDetails(
    id: number,
    successCallback?: SuccessCallback,
    errorCallback?: ErrorCallback,
  ): Promise<ActivityLogDetails> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: `/secure-web/api/private/activity-log/${id}/details`,
        dataAdapter: activityLogDetailsResponseDTOtoActivityLogDetailsAdapter,
        nextCallback: successCallback,
        onErrorCallback: errorCallback,
      },
    });
  }
}

export { ActivityLogRepositoryImpl };
